import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';


const VisitsChart = ({ data }: any) => {

  return (
    <LineChart width={400} height={200} data={data} margin={{ top: 20, right: 20, bottom: 5, left: 0 }}>
      <Line type="monotone" dataKey="visits" stroke="rgba(151, 71, 255, 1)" />
      <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
      <XAxis dataKey="week" />
      <YAxis />
      <Tooltip />
    </LineChart>

  )
};

export default VisitsChart;